// extracted by mini-css-extract-plugin
export default {"container":"styles_container__G-mJe","backDiv":"styles_backDiv__W1ssw","navItemWrapper":"styles_navItemWrapper__0GlVW","navItem":"styles_navItem__Ui7NU"};